/* eslint-disable react/destructuring-assignment */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import DOM from './unauthorisedJourneyReport';

import * as eventsActions from '../../../../core/events/eventsActions';
import * as reportActions from '../../../../core/report/reportActions';
import * as assetActions from '../../../../core/asset/assetActions';

const { DB_DATE_FORMAT } = require('../../../../core/constants').default;

class UnauthorisedJourneyReport extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filters: {},
            filterSidebar: true,
            reportHasBeenFetched: false,
        };
        this.view = DOM;
    }

    componentDidMount() {
        const { actions, dataEventToReportParams } = this.props;
        actions.resetReportsRequest();
        if (dataEventToReportParams !== null) {
            const params = {
                ...dataEventToReportParams,
                page: 1,
            };
            actions.getUnauthorisedJourneyReportRequest(params);
            actions.setDataEventToReportParams(null);

            this.setState({ filters: params, filterSidebar: false });
        } else {
            this.onEventsTabFilterChange({
                asset_or_driver: 'assets',
                frequency: '1',
                page: 1,
            });
        }
    }

    onEventsTabPageChange = (page, pageSize) => {
        const { actions } = this.props;
        const { filters } = this.state;
        filters.page = page;
        actions.getUnauthorisedJourneyReportRequest(filters);
    };

    onEventsTabSortChange = (pagination, x, sorter, extra) => {
        const { actions, unauthorisedJourneyPagination } = this.props;
        const { filters } = this.state;

        // checking when only order changes
        if (pagination && pagination.current.toString() === unauthorisedJourneyPagination.currentPage) {
            const params = { orderBy: `${sorter.order == 'descend' ? '-' : ''}${sorter.field}`, ...filters };
            actions.getUnauthorisedJourneyReportRequest(params);
        }
    };

    onEventsTabFilterChange = (values) => {
        const filters = values;
        if (filters.date_from) {
            filters.date_from = values.date_from.format(DB_DATE_FORMAT);
        }
        if (filters.date_to) {
            filters.date_to = values.date_to.format(DB_DATE_FORMAT);
        }
        if (filters.asset_id) {
            filters.asset_info = values.asset_id;
        }
        filters.page = 1;
        this.setState({ filters });
        const { actions } = this.props;
        const params = { ...filters };

        actions.getUnauthorisedJourneyReportRequest(params);

        this.setState({ reportHasBeenFetched: true });
    };

    render() {
        return this.view(
            {
                update: (newVals) => (
                    this.props.actions.UpdateEventNotifications(newVals)
                ),
            },
        );
    }
}

UnauthorisedJourneyReport.propTypes = {
    actions: PropTypes.object.isRequired,
    unauthorisedJourneyReport: PropTypes.array.isRequired,
};

UnauthorisedJourneyReport.defaultProps = {
    unauthorisedJourneyReport: [],
    unauthorisedJourneyPagination: {
        currentPage: 1,
        totalRecords: 0,
        pageCount: 0,
        perPageCount: 10,
    },
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        unauthorisedJourneyReport: state.report.unauthorisedJourneyReport,
        unauthorisedJourneyPagination: state.report.unauthorisedJourneyPagination,
        events: state.events.companyEvents,
        user: state.user,
        filterSidebar: state.filterSidebar,
        dataEventToReportParams: state.global.dataEventToReportParams,
        isFetching: state.report.isFetching,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...eventsActions,
            ...reportActions,
            ...assetActions,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(UnauthorisedJourneyReport);
